import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IPatientSatisfactionFilters {
    endDate?: Date;
    episodeCategoryId?: string;
    startDate?: Date;
}

export const patientSatisfactionFiltersSchema = Koi.object({
    endDate: Koi.koi().date().endDate().allow(null),
    episodeCategoryId: Koi.string().uuid().optional(),
    startDate: Koi.koi().date().allow(null),
}).options({ convert: false });

export const patientSatisfactionFiltersValidation: ISchemaContainer<IPatientSatisfactionFilters> = {
    schema: patientSatisfactionFiltersSchema,
};
